import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  inject
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { formatDuration } from '../../../../_shared/helpers/helpers';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { TimeStatusIndicatorComponent } from '../../../../_shared/components/time-status-indicator/time-status-indicator.component';
import { EmptyStateComponent } from '../../../../_shared/components/states/empty-state/empty-state.component';
import { ErrorStateComponent } from '../../../../_shared/components/states/error-state/error-state.component';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-driver-activity',
  standalone: true,
  imports: [CommonModule, InfiniteScrollModule, TimeStatusIndicatorComponent, EmptyStateComponent, ErrorStateComponent, TranslocoPipe],
  templateUrl: './driver-activity.component.html',
  styleUrl: './driver-activity.component.scss',
})
export class DriverActivityComponent {
  @Input() title: string = '';
  @Input() count: number = 0;
  @Input() icon: string;
  @Input() columnHeaders: string[] = [];
  @Input() filteredDriversData: any[] = [];
  @Input() isModal: boolean = false;
  @Input() componentId: string = '';
  @Input() isLoading: boolean = true;
  @Input() isPageLoading: boolean = true;
  @Input() isLocationColumn: boolean = false;
  @Input() hasError: boolean = false;
  @Output() toggleExpandEvent = new EventEmitter<string>();
  @Output() scrollEvent = new EventEmitter<void>();

  private activeModal = inject(NgbActiveModal, { optional: true });

  public isExpanded: boolean = false;

  public closeModal(): void {
    if (this.activeModal) {
      this.activeModal.close();
    }
  }

  public toggleExpand(): void {
    this.isExpanded = !this.isExpanded;
    if (this.componentId) {
      this.toggleExpandEvent.emit(this.componentId);
    }
  }

  onScroll(): void {
    this.scrollEvent.emit();
  }

  public getStatusClass(status: string): string {
    return `bg-${status}`;
  }

  public formatDuration(seconds: number): string {
    return formatDuration(seconds);
  }
}